export default class AdControl {
    onLoad(slot) {
        // Custom logic when ad is loaded (e.g., analytics)
    }
    onDestroy(slot) {
        // Custom logic when slot is destroyed
    }
}
